import React         from 'react';
import ReactDom      from 'react-dom';
import Moment        from 'moment';

import Const         from 'fw_const';
import Utils         from 'utils';
import CastingCommon from '@utils/casting-common';

import {Tooltip}        from 'pui-react-tooltip';
import {OverlayTrigger} from 'pui-react-overlay-trigger';
// -------------------------------------------------------

class ProgressCard extends React.Component {
  render() {
    let data = this.props.data;
    let base = this.props.base;
    let influencer = data.influencer;
    
    let status = influencer.status;
    
    let progress_status = CastingCommon.getProgressStatus(data.progress, base.workflow.list, data.is_ng);
    let request_action = CastingCommon.getRequestAction(base, influencer.insta_user_id);
    
    // DM通知確認
    let is_dm_already_read = false;
    try {
      if( base.dm_already_read[influencer.insta_user_id][base.project.detail.main_dm_account] != undefined ) is_dm_already_read = true;
    } catch(e) {}
    
    return (
      <OverlayTrigger placement="top" delayShow={50} overlay={<Tooltip>@{influencer.insta_id}</Tooltip>}>
        <li className={'color_'+ progress_status.color} data-id={influencer.insta_user_id} onClick={base.event.showInfluencer.bind(this, influencer.insta_user_id)}>
          { (influencer.thumbnail != null)
            ? <img src={influencer.thumbnail} onError={(e)=>{e.target.src="/images/default.jpg"}} />
            : <img src="/images/default.jpg" />
          }
          
          { (request_action != null) && <i className={'material-icons info-alert type_'+ request_action}>{( request_action == 'dm' ) ? 'email' : 'info' }</i> }
          { (request_action == 'client_check') && <i className="material-icons info-alert">info</i> }
          
          { (is_dm_already_read == true) && <i className="material-icons dm-already-read">email</i> }
          
          { CastingCommon.getProgressMark(base.workflow.influencers[influencer.insta_user_id]) }
        </li>
  	  </OverlayTrigger>
    );
  }
}
// -------------------------------------------------------

// レンダリング処理
export default ProgressCard;